import { useContext, useEffect, useMemo, useState } from 'react'
import { TransactionContext } from '../../../app/contexts/TransactionContext'
import { useAuth } from '../../../app/hooks/useAuth'
import { useCommissionAmount } from '../../../app/hooks/useCommissionAmount'

export default function useDashboard() {
  const { transactionChart, setFilterParams } = useContext(TransactionContext)
  const { data, isFetching, isLoading } = useMemo(
    () => transactionChart || {},
    [transactionChart],
  )
  const [metric, setMetricState] = useState<'count' | 'total'>(
    () => (sessionStorage.getItem('dashboard:metric') as 'count' | 'total') || 'count'
  )

  const setMetric = (value: 'count' | 'total') => {
    sessionStorage.setItem('dashboard:metric', value)
    setMetricState(value)
  }

  const commissionAmmount = useCommissionAmount()

  const { user, isSeller, isLeader, isManager, isAdmin, isSupervisor } =
    useAuth()

  useEffect(() => {
    if (isSeller && user) {
      setFilterParams({
        sellerIds: user._id,
      })
    }

    // comentario
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSeller, user])

  return {
    user,
    data,
    isLoading: isFetching || isLoading,
    isSeller,
    isLeader,
    isSupervisor,
    isManager,
    isAdmin,
    commissionAmmount: commissionAmmount.data?.amount || 0,
    metric,
    setMetric,
  }
}
